import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { Button } from '../../../components/ui/Button';

export default function PayslipPasswordGate({ onVerify, loading, error }) {
  const [password, setPassword] = useState('');

  function submit(e) {
    e.preventDefault();
    onVerify(password);
  }

  return (
    <div className="min-h-[calc(100vh-120px)] flex items-center justify-center px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-[360px] rounded-xl border border-[var(--border)] bg-[var(--bg-card)] p-5 shadow-sm"
      >
        <div className="w-10 h-10 rounded-xl bg-accent-500/10 text-accent-600 dark:text-accent-400 flex items-center justify-center mb-4">
          <Lock size={20} />
        </div>
        <h2 className="text-lg font-extrabold text-[var(--text)]">급여명세서</h2>
        <p className="text-xs text-[var(--text-muted)] mt-1 mb-4">
          본인 확인을 위해 로그인 비밀번호를 다시 입력해 주세요.
        </p>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full h-10 px-3 rounded-lg border border-[var(--border)] bg-white dark:bg-pine-800 dark:[--autofill-bg:rgb(var(--tw-pine-800))] text-[var(--text)] text-sm focus:outline-none focus:border-accent-500"
          placeholder="비밀번호"
        />
        {error && <div className="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">{error}</div>}
        <Button type="submit" variant="primary" size="sm" className="w-full mt-4" disabled={loading}>
          {loading ? '확인 중...' : '확인'}
        </Button>
      </form>
    </div>
  );
}
